<script setup>
import "~/assets/css/main.css";
import "~/assets/css/cb_custom.css";
import "bootstrap/dist/css/bootstrap.css";
import AdminNavBar from "~/components/Admin/AdminNavBar.vue";
import TopHeaderBar from "~/components/Navigation/TopHeaderBar.vue";

useUserStore();
useFacilityStore();
useCareDayStore();
useMenuStore();

const isMobileView = ref(window.innerWidth < 926);
const handleResize = () => {
  isMobileView.value = window.innerWidth < 926;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<template>
  <div>
    <AdminNavBar />
    <div class="content">
      <div class="container">
        <TopHeaderBar v-if="!isMobileView" />
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped>
.content-container {
  min-width: 300px;
  max-width: 1540px;
  width: auto;
  margin: 20px 40px;
}

.default-container {
  height: 100vh;
  width: 100vw;
}

@media (min-width: 768px) {
  .content {
    margin-left: 232px;
  }
}
</style>
